export const SELECTED_QUOTE = "SELECTED_QUOTE";
